import { MasterLayout } from 'layout/master/main';
import { AppController } from 'app/controller';
import { CompaniesSearchform } from 'module/companiesSearchform/main';
import { CompaniesFilter } from 'module/companiesFilter/main';
import { CompaniesListHeader } from 'module/companiesListHeader/main';
import { CompaniesList } from 'module/companiesList/main';
import { Pagination } from 'module/pagination/main';
import { LoadingOverlay } from 'module/loadingOverlay/main';
import { TIME_SNACKBAR_MEDIUM } from 'app/timings';
import { MAIL_NEVER, MAIL_WEEKLY } from 'app/mailSubscriptionInterval';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { getJson } from 'util/xhr';
import { params as urlWithParams, stringToSlug } from 'util/url';
import { ENDPOINT_COMPANIES } from 'app/endpoints';
import { app } from 'app/app';
import { user } from 'app/user';
import { mediaQueries } from 'util/mediaQueries';
import { trackGa4, sendPageView } from 'util/googleAnalytics';
import deepEqual from 'util/deepEqual';
import { CompanyProposalList } from 'module/companyProposalList/main';
import { CompaniesFilterButtons } from 'module/companiesFilterButtons/main';
import { EmptyResult } from 'module/emptyResult/main';
import { SubNavigation } from 'module/subNavigation/main';
import './styles.scss';

class CompaniesSearchController extends AppController {
    ready() {
        this.updateProps({
            companiesSearchRequest: Object.assign(
                this.companiesSearchform.getProps(),
                this.props.companiesSearchRequest,
                this.companiesFilter.getCompaniesSearchProps(),
            ),
        });

        this.initHistoryApi();
    }

    onPopState(state) {
        if (!state) return; // hashbang fix

        this.setProps(state);
        this.companiesSearchform.setProps(this.props.companiesSearchRequest, true);

        // if we haz a searchrequest and no joblist we do jobsearch weeeeee
        if (state.companiesSearchRequest && !state.companiesList) {
            this.sendSearchRequest(state.companiesSearchRequest, true);
        }
        sendPageView();
    }

    domBindings() {
        return {
            main: '.c-companiesSearch__main',
            searchform: '.c-companiesSearch__searchform',
            topProposals: '.m-companyProposalList--top',
            randomProposals: '.m-companyProposalList--random',
            companyFilterButtons: '.m-companiesFilterButtons',
            subNavigation: '.c-companiesSearch__subNav .m-subNavigation',
        };
    }

    getPropsFromDom() {
        return {
            companyAlarmNotificationInterval:
                parseInt(this.dom.main.getAttribute('data-companyalarmnotificationinterval'), 10),
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);

        this.companiesSearchform = new CompaniesSearchform(this.dom.el.querySelector('.m-companiesSearchform'));
        this.companiesList = new CompaniesList(
            this.dom.el.querySelector('.c-companiesSearch__companiesList .m-companiesList'),
        );
        this.pagination = new Pagination(this.dom.el.querySelector('.m-pagination'));
        this.companiesListHeader = new CompaniesListHeader(this.dom.el.querySelector('.m-companiesListHeader'));
        this.topProposals = new CompanyProposalList(this.dom.topProposals);
        this.randomProposals = new CompanyProposalList(this.dom.randomProposals);
        this.emptyResult = new EmptyResult(this.dom.el.querySelector('.m-emptyResult'));
        this.companiesFilterButtons = new CompaniesFilterButtons(this.dom.companyFilterButtons);
        this.loadingOverlay = new LoadingOverlay(this.dom.el.querySelector('.m-loadingOverlay'));
        this.companiesFilter = new CompaniesFilter(this.dom.el.querySelector('.m-companiesFilter'));
        this.subNavigation = new SubNavigation(this.dom.subNavigation);
    }

    subsProps() {
        if (this.props.companiesSearchRequest) {
            if (this.companiesFilter) {
                // If we send a new keyword/location request we should return to the first page and reset the filter.
                this.companiesFilter.updateCompaniesSearchProps(
                    { page: false, ...this.props.companiesSearchRequest },
                    true,
                );
            }
        }

        if (this.props.companiesListHeader) {
            this.companiesListHeader.setProps(this.props.companiesListHeader, true);
        }

        if (this.props.emptyResult) {
            this.emptyResult.setProps(this.props.emptyResult, true);
        }

        if (this.props.companiesList) {
            this.companiesList.setProps(this.props.companiesList, true);
        }

        if (this.props.companiesFilterButtons) {
            this.companiesFilterButtons.setProps(this.props.companiesFilterButtons, true);
        }

        if (this.props.pagination) {
            this.pagination.setProps(this.props.pagination, true);
        }

        if (this.props.randomProposals) {
            this.randomProposals.setProps(this.props.randomProposals, true);
        }

        if (this.props.topProposals) {
            this.topProposals.setProps(this.props.topProposals, true);
        }
    }

    subEvents() {
        this.companiesFilterButtons.events.on(
            'changedFilter',
            (searchRequest) => {
                this.newSearchRequest(searchRequest.arguments[0].searchRequest);
            },
        );

        this.companiesFilter.events.on('changed', (searchRequest) => {
            if (mediaQueries.isMobile()) {
                this.updateProps({
                    companiesSearchRequest: { ...searchRequest.arguments[0],
                        keywordSlug: '',
                        locationSlug: '',
                        ...this.companiesSearchform.getPropsFromDom() },
                });
                this.newSearchRequest(this.props.companiesSearchRequest);
            } else {
                this.newSearchRequest(searchRequest.arguments[0]);
            }
        });

        this.companiesFilter.events.on('resetCompaniesSearchForm', () => {
            this.companiesSearchform.resetInputValues();
        });

        this.companiesSearchform.events.on(
            'submit',
            (searchRequest) => this.newSearchRequest(searchRequest.arguments[0]),
        );
        this.pagination.events.on('changed', (searchRequest) => {
            window.scrollTo(0, 0);
            this.changedSearchRequest(searchRequest.arguments[0]);
        });
        if (this.companiesFilter) {
            this.companiesFilter.events.on('changed', (searchRequest) => {
                if (mediaQueries.isMobile()) {
                    window.scrollTo(0, 0);
                }
                this.newSearchRequest(
                    Object.assign(searchRequest.arguments[0], { page: false }),
                );
            });
            this.companiesFilter.events.on('resetCompaniesSearchForm', () => {
                this.companiesSearchform.resetInputValues();
            });
        }

        if (this.companiesList) {
            this.companiesList.events.on(
                'changedCompanyTag',
                (searchRequest) => {
                    window.scrollTo(0, 0);
                    this.newSearchRequest(searchRequest.arguments[0]);
                    this.companiesSearchform.setProps(this.props.companiesSearchRequest, true);
                },
            );
            this.companiesList.events.on(
                'changedCompanyLocation',
                (searchRequest) => {
                    window.scrollTo(0, 0);
                    this.newSearchRequest(searchRequest.arguments[0]);
                    this.companiesSearchform.setProps(this.props.companiesSearchRequest, true);
                },
            );
            this.companiesList.events.on(
                'changedSearchRequest',
                (searchRequest) => this.newSearchRequest(searchRequest.arguments[0]),
            );

            if (!user.isLoggedIn()) {
                this.companiesList.events.on('onUnauthorized', (followObject) => {
                    this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
                });
            } else {
                this.companiesList.events.on('onAddJob', () => {
                    let snackbarText;
                    if (this.props.companyAlarmNotificationInterval === MAIL_WEEKLY) {
                        snackbarText = 'Ab sofort erhältst du wöchentlich neue Jobs dieser Firma per E-Mail.';
                    } else {
                        snackbarText = 'Ab sofort erhältst du täglich neue Jobs dieser Firma per E-Mail.';
                    }

                    this.layout.showSnackbar(
                        TIME_SNACKBAR_MEDIUM,
                        false,
                        false,
                        false,
                        false,
                        snackbarText,
                        false,
                        '/settings/notifications#c-notificationIndex-companyalarm',
                        false,
                        'Anpassen',
                    );
                });
                userCompanyFollow.events.on('onRemoveJob', () => {
                    if (this.props.companyAlarmNotificationInterval !== MAIL_NEVER) {
                        this.layout.showSnackbar(
                            TIME_SNACKBAR_MEDIUM,
                            false,
                            false,
                            false,
                            false,
                            'Du erhältst ab sofort keine Jobs dieser Firma mehr per E-Mail.',
                            true,
                            false,
                            false,
                            false,
                        );
                    }
                });
                this.companiesList.events.on('onFollowError', (error) => {
                    [].forEach.call(error.arguments[0].errors, (err) => {
                        if (err.meta.company_follow_max_limit) {
                            this.layout.showSnackbar(
                                TIME_SNACKBAR_MEDIUM,
                                false,
                                false,
                                false,
                                false,
                                'Oje, du hast das Maximum schon erreicht! Um dieser Firma zu folgen, '
                                + 'entfolge einer anderen Firma.',
                                false,
                                '/companyalarm?openAccordion=true',
                                false,
                                'Zum Firmen-Alarm ',
                            );
                        }
                    });
                });
            }
        }
    }

    sendSearchRequest(searchRequest, replaceState = false) {
        this.loadingOverlay.show();

        this.updateProps({
            companiesSearchRequest: searchRequest,
        });

        this.dom.el.querySelector('.m-companiesList').classList.add('m-companiesList--loading');

        const endpoint = this.generateCleanUrl();

        if (this.searchRequest) {
            this.searchRequest.abort();
        }

        this.searchRequest = getJson(
            endpoint,
            {},
            (response) => this.onSearchResponse(response, replaceState),
            (error) => this.onSearchResponseError(error, replaceState),
        );
    }

    newSearchRequest(diffRequest) {
        this.sendSearchRequest({ ...this.props.companiesSearchRequest, ...diffRequest, page: false });
    }

    changedSearchRequest(diffRequest) {
        this.sendSearchRequest({ ...this.props.companiesSearchRequest, ...diffRequest });
    }

    onSearchResponse(responseJson, replaceState) {
        this.loadingOverlay.hide();

        if (!deepEqual(this.props.companiesList, responseJson.companiesList)) {
            // remove watchlist listeners for jobs everytime we render new jobs, except the listing stays the same ...
            userCompanyFollow.events.removeAllListeners();
        }

        this.updateProps(responseJson);

        // html5 history
        if (replaceState) {
            this.replaceState(this.getProps(), responseJson.layout.meta.title, this.generateCleanUrl());
        } else {
            this.pushState(this.getProps(), responseJson.layout.meta.title, this.generateCleanUrl());
        }

        this.dom.el.querySelector('.m-companiesList').classList.remove('m-companiesList--loading');

        this.sendGa4Tracking();
    }

    onSearchResponseError(error, replaceState) {
        if (error.status === 0) {
            // aborted xhr ...
            return;
        }

        this.updateProps({ error });

        if (replaceState) {
            this.replaceState(this.getProps(), `error ${error.status}`, this.generateCleanUrl());
        } else {
            this.pushState(this.getProps(), `error ${error.status}`, this.generateCleanUrl());
        }

        this.dom.el.querySelector('.m-companiesList').classList.remove('m-companiesList--loading');

        this.companiesListHeader.setProps({ error }, true);
        this.companiesList.setProps({ error }, true);
        this.pagination.setProps({ error }, true);
        this.locationProposals.setProps({ error }, true);
        this.randomProposals.setProps({ error }, true);
        this.randomProposals.setProps({ error }, true);
        this.topProposals.setProps({ error }, true);

        this.pushState(this.getProps());
    }

    generateCleanUrl() {
        const searchRequest = this.getProps().companiesSearchRequest;
        const isLandingpage = !!searchRequest.isLandingpage;
        const urlParts = [];
        const urlParams = {};
        const encodedUrlParams = {};
        urlParts.push(ENDPOINT_COMPANIES);

        if (!isLandingpage || searchRequest.keywords
            // %2F = slash, avoid urls like /a/waidhofen%2Fybbs, they are interpreted as /a/waidhofen/ybbs and dont work
            // Instead, such urls should be generated like this -> /a?locations=waidhofen%2Fybbs
            || (searchRequest.locationSlug && searchRequest.locationSlug.includes('%2F'))
            || (searchRequest.location && searchRequest.location.includes('%2F'))) {
            if (searchRequest.locationSlug) {
                encodedUrlParams.locations = searchRequest.locationSlug;
            } else if (searchRequest.locations) {
                urlParams.locations = searchRequest.locations;
            }
        } else {
            if (searchRequest.locationSlug) { // eslint-disable-line no-lonely-if
                urlParts.push(searchRequest.locationSlug);
            } else if (searchRequest.locations) {
                urlParts.push(stringToSlug(searchRequest.locations));
            }
        }

        const url = urlParts.join('/');

        if (searchRequest.page > 1) {
            urlParams.page = searchRequest.page;
        }
        if (searchRequest.keywords) {
            urlParams.keywords = searchRequest.keywords;
        }
        if (searchRequest.businesspageType) {
            urlParams.businesspageType = Object.keys(searchRequest.businesspageType);
        }
        if (searchRequest.branches) {
            urlParams.branches = Object.keys(searchRequest.branches);
        }
        if (searchRequest.benefits) {
            urlParams.benefits = Object.keys(searchRequest.benefits);
        }
        if (searchRequest.states) {
            urlParams.states = Object.keys(searchRequest.states);
        }
        if (searchRequest.countries) {
            urlParams.countries = Object.keys(searchRequest.countries);
        }
        if (searchRequest.sort && searchRequest.sort === 'date') {
            urlParams.sort = 'date';
        }

        return urlWithParams(url, urlParams, encodedUrlParams);
    }

    sendGa4Tracking() {
        let keywords = null;

        if (this.companiesSearchform.props.keywords) {
            if (this.companiesSearchform.props.keywords.length) {
                keywords = this.companiesSearchform.props.keywords.toLowerCase();
            }
        }

        let locations = null;

        if (this.companiesSearchform.props.locations) {
            if (this.companiesSearchform.props.locations.length) {
                locations = this.companiesSearchform.props.locations.toLowerCase();
            }
        }

        // Keys to check
        const keysToCheck = ['businesspageType', 'branches', 'benefits', 'states', 'countries'];

        // Function to filter specific keys with non-empty values
        const getNonEmptyKeys = (obj, keys) => keys.filter((key) => {
            const value = obj[key];
            // Check if the value is truthy and not an empty object or array
            if (value && typeof value === 'object') {
                return Object.keys(value).length > 0;
            }
            return Boolean(value);
        });

        // Convert to a comma-separated string
        const filterUsed = getNonEmptyKeys(this.companiesFilter.props, keysToCheck).join(', ') || null;

        if (keywords || locations || filterUsed) {
            const formatKeys = (obj) => (obj && Object.keys(obj).length > 0 ? Object.keys(obj).join(', ') : null);

            trackGa4({
                event: 'search',
                keywords: keywords || null,
                locations: locations || null,
                filters: filterUsed,
                benefits: formatKeys(this.companiesFilter.props.benefits),
                branches: formatKeys(this.companiesFilter.props.branches),
                businesspageType: formatKeys(this.companiesFilter.props.businesspageType),
                states: formatKeys(this.companiesFilter.props.states),
                form_type: 'Company Search',
            });
        }
    }
}

app.boot(CompaniesSearchController);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(CompaniesSearchController);
    });

    module.hot.accept(() => {});
}
